module.exports = __webpack_public_path__ + "static/img/bannerMin.851ed9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannerMin.png
// module id = Y+iO
// module chunks = 1